import { FronteggContext } from '@frontegg/rest-api';
import {
  addSpecialtyConfig,
  deleteSpecialtyConfig,
  editSpecialtyConfig,
  generateOnboardingScriptConfig,
  getAllSpecialtiesConfig,
  getSpecialtyByIdConfig,
} from '../lib/specialty.url';
import { Axios, AxiosAmbient } from 'src/lib';
import { getAllSpecialtiesListSlice } from '../slices';
import {
  getAllSpecialtiesDropdownSlice,
  getAllSpecialtyByIdSlice,
  getGeneratedScriptLoadingSlice,
  getGeneratedScriptSlice,
} from '../slices/specialty.slice';
import { superAdminLoadingSlice } from '../slices/condition.slice';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';

export const getAllSpecialtyListAction = () => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getAllSpecialtiesConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.specialties;
      if (result?.status === 200 && response) {
        dispatch(superAdminLoadingSlice(false));
        dispatch(getAllSpecialtiesListSlice(response));
        //The below is used only for dropdown values since the list slice will be reused when filtering data
        dispatch(getAllSpecialtiesDropdownSlice(response));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const addSpecialtyAction = (
  payload,
  setIsOpen,
  setIsPublic,
  isfilterOn,
  selectedSpecialty,
  setSpecialty
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = addSpecialtyConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 201) {
        dispatch(superAdminLoadingSlice(false));
        isfilterOn
          ? dispatch(getSpecialtyByIdAction(selectedSpecialty, null, 'filter'))
          : dispatch(getAllSpecialtyListAction());
        setIsOpen(false);
        setIsPublic(false);
        dispatch(getGeneratedScriptSlice({}));
        setSpecialty(null);
        showToastSuccess('Specialty created successfully');
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const getSpecialtyByIdAction = (specialty_id, setIsOpen, action) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getSpecialtyByIdConfig(specialty_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(superAdminLoadingSlice(false));
        dispatch(getAllSpecialtyByIdSlice(response));
        setIsOpen ? setIsOpen(true) : null;
        if (action === 'filter') {
          let list = [];
          if (
            typeof response === 'object' &&
            JSON.stringify(response) === '{}'
          ) {
            null;
          } else {
            list = [response];
          }
          dispatch(getAllSpecialtiesListSlice(list));
        }
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const editSpecialtyAction = (
  specialty_id,
  payload,
  setEditModalOpen,
  isfilterOn,
  selectedSpecialty
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = editSpecialtyConfig(specialty_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.put(url, payload, { headers });
      if (result?.status === 200) {
        dispatch(superAdminLoadingSlice(false));
        setEditModalOpen ? setEditModalOpen(false) : null;
        isfilterOn
          ? dispatch(getSpecialtyByIdAction(selectedSpecialty, null, 'filter'))
          : dispatch(getAllSpecialtyListAction());
        showToastSuccess('Specialty updated successfully');
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const deleteSpecialtyAction = (
  specialty_id,
  setIsOpen,
  isfilterOn,
  selectedSpecialty
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = deleteSpecialtyConfig(specialty_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.delete(url, { headers });
      if (result?.status === 200) {
        dispatch(superAdminLoadingSlice(false));
        setIsOpen(false);
        isfilterOn
          ? dispatch(getSpecialtyByIdAction(selectedSpecialty, null, 'filter'))
          : dispatch(getAllSpecialtyListAction());
        showToastSuccess('Specialty deleted successfully');
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const generateOnboardingScript = (specialty) => {
  return async (dispatch) => {
    dispatch(getGeneratedScriptLoadingSlice(true));
    try {
      const { url } = generateOnboardingScriptConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const data = {
        specialty_name: specialty,
      };
      const result = await AxiosAmbient.post(url, data, { headers });
      if (result?.status === 200) {
        dispatch(getGeneratedScriptLoadingSlice(false));
        dispatch(getGeneratedScriptSlice(result?.data));
      }
    } catch (e) {
      dispatch(getGeneratedScriptLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};
